import { useState } from 'react';
import { usePwaUpdate } from '../../hooks/usePwaUpdate';
import { useI18n } from '../../hooks/useI18n';
import { ArrowClockwise } from '../ui/icons';
import Button from '../ui/Button';

export default function PwaUpdateBanner() {
  const { t } = useI18n();
  const { needRefresh, updateReady } = usePwaUpdate();
  const [updating, setUpdating] = useState(false);

  if (!needRefresh) return null;

  const handleUpdate = () => {
    if (updating) return;
    setUpdating(true);
    updateReady();
  };

  return (
    <div className="fixed left-1/2 top-[calc(var(--snap-top,0px)+0.75rem)] z-40 flex w-[calc(100%-2rem)] max-w-2xl -translate-x-1/2 items-center gap-3 rounded-2xl border-2 border-amber-400/80 bg-surface/98 px-4 py-3 shadow-[0_10px_35px_rgba(0,0,0,0.18)] backdrop-blur-xl sm:px-5">
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-sm font-semibold text-ink">{t('pwa_update_title')}</span>
        <span className="text-xs text-muted">{t('pwa_update_description')}</span>
      </div>
      <Button
        type="button"
        variant="glass-primary"
        size="sm"
        onClick={handleUpdate}
        disabled={updating}
        className="shrink-0 min-w-32"
      >
        <ArrowClockwise className={`h-4 w-4 ${updating ? 'animate-spin' : ''}`} aria-hidden="true" />
        {updating ? 'Actualizando…' : t('pwa_update_confirm')}
      </Button>
    </div>
  );
}